
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private counter = 0;
  private _visible$ = new BehaviorSubject<boolean>(false);

  /**
   * When true, the loader overlay is suppressed (e.g. in landing/embed mode
   * where a widget-scoped indicator is used instead).
   */
  private _suppressed = false;

  /** Public observable the overlay component will subscribe to */
  get visible$(): Observable<boolean> {
    return this._visible$.asObservable();
  }

  /** Suppress the global loader overlay (used in landing/embed mode). */
  suppress(): void {
    this._suppressed = true;
    this._visible$.next(false);
  }

  /** Unsuppress (restore normal behaviour). */
  unsuppress(): void {
    this._suppressed = false;
    if (this.counter > 0) {
      this._visible$.next(true);
    }
  }

  /** Show the loader (increments the counter) */
  show(): void {
    this.counter++;
    if (this.counter === 1 && !this._suppressed) {
      this._visible$.next(true);
    }
  }

  /** Hide the loader (decrements the counter safely) */
  hide(): void {
    if (this.counter > 0) {
      this.counter--;
      if (this.counter === 0) {
        this._visible$.next(false);
      }
    }
  }

  /** Force-hide to reset bad states (optional) */
  reset(): void {
    this.counter = 0;
    this._visible$.next(false);
  }
}
